import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import TextEditor from '../../../../TextEditor'
import { useEffect } from 'react'
import { useState } from 'react'
import { ModalBody, ModalFooter } from 'reactstrap'
import CustomModal from '../CustomModal'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'

const ManageText = (props) => {
  const [text, setText] = useState(null)

  let language = props.language || {}

  const onChange = (newContent) => {
    //   let newContent = evt.editor.getData()
    props.onChangeText('textContent', newContent)
  }

  useEffect(() => {
    props.fetchTextContent(props.match.params.id)
    return () => {
      props.onChangeText('textContent', '')
    }
  }, [])

  useEffect(() => {
    if (props.content) {
      const selectedText = props.content.find((item) =>
        item.id === parseInt(props.match.params.id) ? item : null
      )
      setText(selectedText)
    }
  }, [props.content, props.match.params.id])

  return (
    <CustomModal courseId={props.course_id} title='Edit Text' size='xl'>
      <ModalBody>
        <div className='row'>
          <div className='col-md-4 title-container'>
            <div className='upload-video-form-row'>
              <label>{language?.settings.title}: </label>
              <input
                type='text'
                name='title'
                autoFocus
                value={props.title ? props.title : ''}
                onChange={(event) =>
                  props.onChangeTitleText(event.target.value)
                }
              />
            </div>
          </div>
        </div>

        <TextEditor
          textContent={props.textContent}
          onChangeText={(event) => props.onChangeText('textContent', event)}
          setOptions={{
            buttonList: [
              [
                'undo',
                'redo',
                'font',
                'fontSize',
                'formatBlock',
                'list',
                'align',
                'fontColor',
              ],
              ['bold', 'underline', 'italic', 'horizontalRule'],
              ['codeView', 'outdent', 'indent'],
              ['table', 'image', 'link'],
            ],
          }}
        />

        <div className='custom-control custom-checkbox-info mt-2'>
          <input
            className='custom-control-input'
            id='required_content'
            type='checkbox'
            checked={props.requiredContent}
            onChange={props.setRequired}
          />
          <label
            className='custom-control-label '
            htmlFor='required_content'
            style={{ fontSize: '14px', paddingTop: '2px' }}
          >
            {language?.courses?.required}
          </label>
        </div>
      </ModalBody>
      <ModalFooter className='d-flex justify-content-start mt-3'>
        <Link to={`/course/${props.id}/edit`}>
          <SubmitModalButton
            text={language.general ? language.general.submit : null}
            customFn={() => props.saveTextContent(text.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <DeleteButton
            text={language.general ? language.general.delete : null}
            customFn={() => props.deleteContent(text.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
          />
        </Link>
      </ModalFooter>
    </CustomModal>
  )
}

export default ManageText
